import { DashboardEquipmentType } from '@ifit/equipment-types';
import { IUpNextItem, IUpNextItemType } from '@ifit/gateway-wolf-dashboard-service';
import { DefaultImages } from '@ifit/img/out/defaults';
import { Text } from './text';

export function getFallbackParamountItem(equipmentType: string): IUpNextItem {
  const dashboardEquipmentType = equipmentType as DashboardEquipmentType;

  switch (dashboardEquipmentType) {
    case DashboardEquipmentType.Cycle:
      return getFallbackCycleParamountItem();
    case DashboardEquipmentType.Rower:
      return getFallbackRowerParamountItem();
    case DashboardEquipmentType.Strength:
      return getFallbackStrengthParamountItem();
    case DashboardEquipmentType.Run:
    default:
      return getFallbackRunParamountItem();
  }
}

export function getFallbackRunParamountItem(): IUpNextItem {
  return {
    type: IUpNextItemType.StaffPickWorkout,
    title: Text.paramountItemRunTitle,
    subtitle: null,
    leadLine: Text.paramountItemLeadline,
    callToAction: Text.paramountItemActionText,
    callToActionShort: Text.paramountItemActionText,
    tagPrimary: null,
    imageUrl: DefaultImages.Hero,
    navigationUrl: 'https://www.ifit.com/workout/5e1ca2bdf056f1051f8a77a0',
    isLive: false,
    progress: null,
    averageRating: null,
    workoutId: '5e1ca2bdf056f1051f8a77a0',
    seriesId: null,
    isSeriesCompleted: null,
    workoutLabelsCount: null,
  };
}

export function getFallbackCycleParamountItem(): IUpNextItem {
  return {
    type: IUpNextItemType.StaffPickWorkout,
    title: Text.paramountItemCycleTitle,
    subtitle: null,
    leadLine: Text.paramountItemLeadline,
    callToAction: Text.paramountItemActionText,
    callToActionShort: Text.paramountItemActionText,
    tagPrimary: null,
    imageUrl: DefaultImages.Hero,
    navigationUrl: 'https://www.ifit.com/workout/5f8094b837521c000741ac46',
    isLive: false,
    progress: null,
    averageRating: null,
    workoutId: '5f8094b837521c000741ac46',
    seriesId: null,
    isSeriesCompleted: null,
    workoutLabelsCount: null,
  };
}

export function getFallbackRowerParamountItem(): IUpNextItem {
  return {
    type: IUpNextItemType.StaffPickWorkout,
    title: Text.paramountItemRowerTitle,
    subtitle: null,
    leadLine: Text.paramountItemLeadline,
    callToAction: Text.paramountItemActionText,
    callToActionShort: Text.paramountItemActionText,
    tagPrimary: null,
    imageUrl: DefaultImages.Hero,
    navigationUrl: 'https://www.ifit.com/workout/6064aed7a15adb0008ecb44b',
    isLive: false,
    progress: null,
    averageRating: null,
    workoutId: '6064aed7a15adb0008ecb44b',
    seriesId: null,
    isSeriesCompleted: null,
    workoutLabelsCount: null,
  };
}

export function getFallbackStrengthParamountItem(): IUpNextItem {
  return {
    type: IUpNextItemType.StaffPickWorkout,
    title: Text.paramountItemStrengthTitle,
    subtitle: null,
    leadLine: Text.paramountItemLeadline,
    callToAction: Text.paramountItemActionText,
    callToActionShort: Text.paramountItemActionText,
    tagPrimary: null,
    imageUrl: DefaultImages.Hero,
    navigationUrl: 'https://www.ifit.com/workout/5e0a3bd257e947043a125895',
    isLive: false,
    progress: null,
    averageRating: null,
    workoutId: '5e0a3bd257e947043a125895',
    seriesId: null,
    isSeriesCompleted: null,
    workoutLabelsCount: null,
  };
}
